import * as THREE from 'three';

/** Fit independent estimated axes, keeping the building's centre and ground contact. */
export function fitBuilding(object:THREE.Object3D, target:{width:number;height:number;depth:number}, rotationDeg?:number) {
  if(![target.width,target.height,target.depth].every(n=>Number.isFinite(n)&&n>0))throw new Error('Ungültige Gebäudemaße.');
  object.updateWorldMatrix(true,true);
  const before=new THREE.Box3().setFromObject(object),center=before.getCenter(new THREE.Vector3());
  const rotation=object.quaternion.clone();object.quaternion.identity();object.updateWorldMatrix(true,true);
  const size=new THREE.Box3().setFromObject(object).getSize(new THREE.Vector3());
  object.quaternion.copy(rotation);
  if(![size.x,size.y,size.z].every(n=>Number.isFinite(n)&&n>0))throw new Error('Modellabmessungen fehlen.');
  object.scale.multiply(new THREE.Vector3(target.width/size.x,target.height/size.y,target.depth/size.z));
  if(rotationDeg!==undefined)object.rotation.y=THREE.MathUtils.degToRad(rotationDeg);
  object.updateWorldMatrix(true,true);
  const after=new THREE.Box3().setFromObject(object),next=after.getCenter(new THREE.Vector3());
  object.position.add(new THREE.Vector3(center.x-next.x,before.min.y-after.min.y,center.z-next.z));
  object.updateWorldMatrix(true,true);
  return object.scale.toArray();
}

export function restoreBuildingScale(object:THREE.Object3D, cfg:any, fallback:number, multiplier=1) {
  if(Array.isArray(cfg.scale_xyz)&&cfg.scale_xyz.length===3&&cfg.scale_xyz.every((n:any)=>Number.isFinite(n)&&n>0))object.scale.fromArray(cfg.scale_xyz).multiplyScalar(multiplier);
  else object.scale.setScalar(fallback);
}
